import { Component, Input, OnInit } from '@angular/core';
import { BusinessProcessService } from '../../../../../services/business-process.service';
import {BsModalRef} from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-flow-details',
  templateUrl: './library-item-details.component.html',
  styleUrls: ['./library-item-details.component.css']
})
export class LibraryItemDetailsComponent implements OnInit {

  @Input() modalTitle: string;
  objId: number;
  objMessage: string;
  errorMessage: string;
  businessProcessId: number;
  designElementType: number;
  data = [];

  constructor(
    private bpService: BusinessProcessService,
    public bsModalRef: BsModalRef,
  ) { }

  ngOnInit() {
    this.businessProcessId = Number(this.objMessage.split('|')[0]);
    this.designElementType = Number(this.objMessage.split('|')[1]);
    this.bpService.getReferencingStates(this.businessProcessId, this.objId, this.designElementType)
      .subscribe(
        d => { this.data = d; console.log(d); },
        error1 => this.errorMessage = error1
      );
  }

  onClose() {
    this.bsModalRef.hide();
  }
}
